import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics } from './events';
import { ymHit } from './metrika';

/**
 * Невидимый компонент: запускает счётчики и шлёт в Метрику просмотр на каждый
 * SPA-переход (включая первый). GA4 и Amplitude ловят переходы сами через History API.
 * Монтируется внутри <BrowserRouter>.
 *
 * Ссылки из писем несут секрет в ?token= (подтверждение почты, сброс пароля). Пока он
 * в адресе, счётчики не стартуют и просмотр не уходит — иначе токен попадёт в Метрику,
 * GA4 и Amplitude. Подтверждение почты и сброс пароля убирают токен из адреса сразу после
 * открытия (setSearchParams, replace).
 *
 * Просмотр уходит с задержкой HIT_DELAY_MS и отменяется, если адрес успел смениться:
 * мгновенный редирект (catch-all → «/», гость → /auth) даёт один просмотр итоговой
 * страницы, а не два — без ложных /login в отчётах Метрики.
 */
const HIT_DELAY_MS = 100;

export function AnalyticsTracker() {
  const location = useLocation();
  const prev = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (new URLSearchParams(location.search).has('token')) return;
    initAnalytics(); // идемпотентно; гарантирует init до первого hit
    const url = window.location.origin + location.pathname + location.search;
    const timer = window.setTimeout(() => {
      ymHit(url, prev.current);
      prev.current = url;
    }, HIT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
